import type { CreateCategoryGroup } from '@mynt/backoffice-api-spec/spendcontrols'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SPEND_CATEGORIES } from 'api/react-query/keys'
import { createCategoryGroup } from 'SpendControl/endpoints'

export const useCreateCategoryGroup = () => {
  const client = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateCategoryGroup) => createCategoryGroup(params),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: [SPEND_CATEGORIES] })
    },
  })
}
